import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LOAN_CIC_FEE_REASONS_ACTION_TYPE_V2 } from '../actions';

const initialState = {
  cicChangeReasons: [],
  cureBaseline: null,
};

const loanCicChangeFeeReasonsV2Reducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case LOAN_CIC_FEE_REASONS_ACTION_TYPE_V2.GET_LOAN_CIC_FEE_REASONS:
        return payload || initialState;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default loanCicChangeFeeReasonsV2Reducer;
